export default {
  buildRanges(levels) {
    let gradeLevels = []
    let ranges = []
    for (let level of levels) {
      gradeLevels.push(level)
    }
    gradeLevels.sort((a, b) => a - b)
    for (let level of gradeLevels) {
      let lastRange = ranges.length ? ranges[ranges.length - 1] : null

      if (lastRange && lastRange.levels.includes(level - 1)) {
        lastRange.high = level
        lastRange.levels.push(level)
      } else {
        ranges.push({
          low: level,
          levels: [level]
        })
      }
    }
    return ranges
  }
}
